import React, { FC, useEffect, useState } from 'react'
import s from './Articles.module.scss'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import CardArticle from '../../components/CardArticle/CardArticle'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByArticles } from '../../store/slices/articlesSlice'
import Loader from '../../components/Loader/Loader'
import { LayoutGroup } from 'framer-motion'
import ModalDetailArticle from './ModalDetailArticle/ModalDetailArticle'
import { IArticles } from '../../store/types'
import { Helmet } from 'react-helmet-async'

const Articles: FC = () => {
    const { articles, loading } = useAppSelector(state => state.articles)
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [data, setData] = useState<null | IArticles>(null);
    const dispatch = useAppDispatch()

    useEffect(() => {
        scrollToTop()
        dispatch(fetchByArticles())
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta property="og:title" content="Статьи | Автоматизация технологических процессов и производств" />
                <meta property="og:description" content="Читайте статьи от Phoenix Programs о передовых решениях в автоматизации и различных отраслях. Узнайте о новых технологиях и трендах в нашей сфере." />
                <meta name="twitter:title" content="Статьи | Автоматизация технологических процессов и производств" />
                <meta name="twitter:description" content="Читайте статьи от Phoenix Programs о передовых решениях в автоматизации и различных отраслях. Узнайте о новых технологиях и трендах в нашей сфере." />
                <link rel="canonical" href="https://phoenix-programs.com/articles" />
                <title>Статьи | Автоматизация технологических процессов и производств | Phoenix Programs</title>
            </Helmet>
            {loading && <Loader />}
            <LayoutGroup id={"articles"}>
                <TopBanner title='Статьи' />
                <Breadcrumbs>
                    <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink>
                    /
                    <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/articles'} >Статьи</NavLink>
                </Breadcrumbs>
                <section className={s.section}>
                    <div className={`${s.wrapper} container`}>
                        {
                            articles?.map((el) => (
                                <CardArticle key={el.id} data={el} setData={setData} setSelectedId={setSelectedId} />
                            ))
                        }
                    </div>
                </section>
                <ModalDetailArticle setSelectedId={setSelectedId} selectedId={selectedId} data={data} />
            </LayoutGroup>
        </>
    )
}

export default Articles